// extracted by mini-css-extract-plugin
export const popupOuter = "error-module--popupOuter--3kpgq";
export const popupBox = "error-module--popupBox--3rYyp";
export const popupMessage = "error-module--popupMessage--kpPTl";
export const btnOuter = "error-module--btnOuter--2JpwF";
export const btn = "error-module--btn--3JXmu";